import { ITimeRangeOption } from './types';

export const TIME_RANGE_1_HOUR_OPTION: ITimeRangeOption = { label: '1h', value: 1 };
export const TIME_RANGE_3_HOUR_OPTION: ITimeRangeOption = { label: '3h', value: 3 };
export const TIME_RANGE_6_HOUR_OPTION: ITimeRangeOption = { label: '6h', value: 6 };
export const TIME_RANGE_12_HOUR_OPTION: ITimeRangeOption = { label: '12h', value: 12 };

export const TIME_RANGE_OPTIONS: ITimeRangeOption[] = [
  TIME_RANGE_1_HOUR_OPTION,
  TIME_RANGE_3_HOUR_OPTION,
  TIME_RANGE_6_HOUR_OPTION,
  TIME_RANGE_12_HOUR_OPTION,
];
